import React, { FC } from 'react';
import { Switch, Route } from 'react-router-dom';

import { paths } from '../Root/paths';

import Content from '../../components_/Content';

import Tabs from './Tabs';

import UsersList from './Users/List';
import UsersForm from './Users/Form';
import DepartamentsTree from './Departaments/Tree';

const Staff: FC = () => {
  return (
    <Switch>
      {/* Формы */}
      <Route path={[paths.staff.users.create, paths.staff.users.edit()]} component={UsersForm} />

      {/* Списки */}
      <Route path={paths.staff.root}>
        <Content title="Персонал">
          <Tabs />
          <Switch>
            <Route exact path={paths.staff.root} component={UsersList} />
            <Route exact path={paths.staff.departaments.root} component={DepartamentsTree} />
          </Switch>
        </Content>
      </Route>
    </Switch>
  );
};

export default Staff;
